"use strict";

/**
 * Define Global Variables
 */
var video = new VideoComponent();
var nav = new NavComponent();
var slider = new SliderComponent();
var gallery = new GalleryComponent();
var layout = new Layout();